var _circle, _path, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAlternativeMenu = function SvgAlternativeMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 1.5,
    r: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 13c-.83 0-1.5.67-1.5 1.5S7.17 16 8 16s1.5-.67 1.5-1.5S8.83 13 8 13z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 1.5
  })));
};
export { SvgAlternativeMenu as ReactComponent };
export default "data:image/svg+xml,%3csvg version='1.1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' width='16' height='16' %3e %3cg%3e %3ccircle cx='8' cy='1.5' r='1.5'/%3e %3cpath d='M8,13c-0.83,0-1.5,0.67-1.5,1.5C6.5,15.33,7.17,16,8,16c0.83,0,1.5-0.67,1.5-1.5C9.5,13.67,8.83,13,8,13z'/%3e %3ccircle cx='8' cy='8' r='1.5'/%3e %3c/g%3e %3c/svg%3e";